import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { BreezeLogo, Checkbox, LayoutBox, LayoutHorizontal } from 'breeze-intelligence-kit';
import { useEnrichmentProperties } from './useEnrichmentProperties';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssociatedRecords = () => {
  const {
    associatedRecordsCount,
    enrichAssociatedRecords,
    hasAssociatedRecords,
    isContactEnrichment,
    onToggleEnrichAssociatedRecords
  } = useEnrichmentProperties();
  const {
    companyLabelLowercase,
    contactLabelLowercase,
    contactLabelPluralLowercase
  } = useEnrichableObjectTypes();
  if (!hasAssociatedRecords) {
    return null;
  }
  return /*#__PURE__*/_jsxs(LayoutHorizontal, {
    borderBlockStart: "border",
    gap: "space-lg",
    paddingBlock: "space",
    paddingInlineStart: "space-3xl",
    children: [/*#__PURE__*/_jsx(LayoutBox, {
      flex: "0 0 auto",
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: enrichAssociatedRecords,
        onChange: onToggleEnrichAssociatedRecords,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.panel.associatedRecords.checkboxLabel",
          options: {
            count: associatedRecordsCount,
            objectType: isContactEnrichment ? companyLabelLowercase : contactLabelLowercase
          }
        })
      })
    }), /*#__PURE__*/_jsxs(LayoutHorizontal, {
      gap: "space-xs",
      children: [/*#__PURE__*/_jsx(BreezeLogo, {
        inlineSize: "1.5rem",
        insetBlockStart: "space-2xs",
        position: "relative"
      }), isContactEnrichment ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "enrichmentProperties.panel.associatedRecords.attemptedEnrichmentContact",
        options: {
          objectType: companyLabelLowercase
        }
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "enrichmentProperties.panel.associatedRecords.attemptedEnrichmentCompany",
        options: {
          count: associatedRecordsCount,
          objectType: associatedRecordsCount !== 1 ? contactLabelPluralLowercase : contactLabelLowercase
        }
      })]
    })]
  });
};